import React from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

function RouterErrorBoundary() {
    const error = useRouteError();

    // Solo log en consola; nunca mostrar stack ni detalles técnicos al usuario
    console.error('Router Error:', error);

    const handleReload = () => {
        window.location.reload();
    };

    const handleHome = () => {
        window.location.href = '/';
    };

    let title = 'Algo salió mal';
    let message = 'Ha ocurrido un error al cargar esta página. Por favor, intenta de nuevo.';

    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            title = 'Página no encontrada';
            message = 'La página que buscas no existe o fue movida.';
        }
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50vh',
            padding: '20px',
            backgroundColor: '#f8f9fa',
            fontFamily: 'Arial, sans-serif'
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                textAlign: 'center',
                maxWidth: '400px',
                width: '100%'
            }}>
                <div style={{ marginBottom: '15px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                </div>

                <h2 style={{
                    color: '#dc3545',
                    marginBottom: '15px',
                    fontSize: '20px'
                }}>
                    {title}
                </h2>

                <p style={{
                    color: '#6c757d',
                    marginBottom: '20px',
                    lineHeight: '1.5',
                    fontSize: '14px'
                }}>
                    {message}
                </p>

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                    <button
                        type="button"
                        onClick={handleHome}
                        style={{
                            backgroundColor: '#6c757d',
                            color: 'white',
                            border: 'none',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}
                    >
                        Ir al inicio
                    </button>
                    <button
                        type="button"
                        onClick={handleReload}
                        style={{
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}
                    >
                        Recargar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RouterErrorBoundary;
